export const emailDomainChecker = (
  email: string,
  checkingList: string[],
): boolean => {
  return checkingList.some(checkingItem => email.toLowerCase().includes(checkingItem.toLowerCase()));
};
